import { render } from "./hospedaje_ingles.vue?vue&type=template&id=3b65be7b&scoped=true"
import script from "./hospedaje_ingles.vue?vue&type=script&lang=js"
export * from "./hospedaje_ingles.vue?vue&type=script&lang=js"

import "./hospedaje_ingles.vue?vue&type=style&index=0&id=3b65be7b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b65be7b"]])

export default __exports__